"use strict";
/**
 * Community routes
 */
/* tslint:disable */
module.exports = [
    {
        path: '/member-advocates',
        redirect: { name: 'community-leads' },
    },
    {
        path: '/community-leads',
        name: 'community-leads',
        component: function () { return import(/* webpackChunkName: 'community' */ 'Views/Community/MemberAdvocates/MemberAdvocates.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Community Leads',
        },
    },
    {
        path: '/members',
        component: function () { return import(/* webpackChunkName: 'community' */ 'Views/Community/Members/Members.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Community',
        },
    },
    {
        path: '/contacts',
        component: function () { return import(/* webpackChunkName: 'community' */ 'Views/Community/Contacts/Contacts.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Contacts',
        },
    },
    {
        path: '/contacts/pending',
        component: function () { return import(/* webpackChunkName: 'community' */ 'Views/Community/ContactsPending/ContactsPending.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Pending Contacts',
        },
    },
];
/* tslint:enable */



// WEBPACK FOOTER //
// ./~/ts-loader??ref--3!./src/js/Router/Routes/Community.ts